import React, { useEffect, useRef, useState } from 'react';
import upload from '../../../../../assets/image/upload.svg';
import lightTheme from '../../../../../assets/image/light_theme.png';
import darkTheme from '../../../../../assets/image/dark_theme.png';
import Button from '../../../../../component/ui/Button';
import { toast } from 'react-toastify';
import {
	getBranding,
	updateBranding,
	updateOrganizationLogo,
} from '../../../../../services/settings/organization';
import SettingHeaderComponent from '../../components/settingHeaderComponent';

export default function Branding({ activeTab }) {
	const [isEdit, setIsEdit] = useState(false);
	const [loader, setLoader] = useState(false);
	const [selectedFile, setSelectedFile] = useState(null);
	const [isDragging, setIsDragging] = useState(false);
	const [uploadedLogo, setUploadedLogo] = useState(null);
	const [branding, setBranding] = useState({});
	const [brandingProfile, setBrandingProfile] = useState({
		isDark: true,
		organisation_logo: null,
	});
	const fileInputRef = useRef(null);

	const handleFileSelect = (file) => {
		if (file && file.type.startsWith('image/')) {
			setSelectedFile(file);

			const reader = new FileReader();
			reader.onloadend = () => {
				const imageUrl = reader.result;
				setUploadedLogo(imageUrl);
			};
			reader.readAsDataURL(file);
		} else {
			alert('Please select a valid image file');
		}
	};

	const handleFileInput = (e) => {
		const file = e.target.files[0];
		handleFileSelect(file);
	};

	const handleDragOver = (e) => {
		e.preventDefault();
		setIsDragging(true);
	};

	const handleDragLeave = (e) => {
		e.preventDefault();
		setIsDragging(false);
	};

	const handleDrop = (e) => {
		if (
			selectedFile === null &&
			(brandingProfile.organisation_logo === null || brandingProfile.organisation_logo === '')
		) {
			e.preventDefault();
			setIsDragging(false);
			const file = e.dataTransfer.files[0];
			handleFileSelect(file);
		}
	};

	const handleBoxClick = () => {
		if (
			selectedFile === null &&
			(brandingProfile.organisation_logo === null || brandingProfile.organisation_logo === '')
		) {
			fileInputRef.current.click();
		}
	};
	const handleRemove = (e) => {
		e.stopPropagation();
		setSelectedFile(null);
		setUploadedLogo(null);
		if (fileInputRef.current) {
			fileInputRef.current.value = '';
		}
		handleForm('organisation_logo', null);
	};
	const handleUploadLogo = async (e) => {
		e.stopPropagation();
		try {
			const formData = new FormData();
			formData.append('logo', selectedFile);
			const { organisation } = await updateOrganizationLogo(formData);
			handleForm('organisation_logo', organisation.organisation_logo);
			toast.success('Organisation logo uploaded successfully');
		} catch (error) {
			toast.error(error.message || 'Something went wrong!');
		}
	};
	const handleForm = (key, value) => {
		setBrandingProfile((prev) => ({
			...prev,
			[key]: value,
		}));
	};

	const handlebrandingSave = async () => {
		try {
			setIsEdit(false);
			setLoader(true);
			const body = {
				organisation_logo: brandingProfile.organisation_logo || '',
				theme_preference: brandingProfile.isDark ? 'dark' : 'light',
			};
			const res = await updateBranding(body);
			if (res.success) {
				toast.success(res.message);
			} else {
				setIsEdit(true);
				toast.error(res.message || 'something went wrong!');
			}
		} catch (error) {
			setIsEdit(true);
			toast.error(error.message || 'something went wrong!');
		} finally {
			setIsEdit(false);
			setLoader(false);
		}
	};

	const getBrandingDetail = async () => {
		try {
			const { theme_preference, organisation_logo } = await getBranding();
			const theme = theme_preference === 'light' ? false : true;
			// setIsDark(theme);
			// setOrganisationLogo(organisation_logo);
			const data = {
				isDark: theme,
				organisation_logo: organisation_logo,
			};
			setBrandingProfile(data);
			setBranding(data);
		} catch (error) {
			toast.error(error.message || 'Something went wrong!');
		}
	};

	const getShowUndoChanged = () => {
		const hasChanged = JSON.stringify(branding) !== JSON.stringify(brandingProfile);
		setIsEdit(hasChanged);
	};

	useEffect(() => {
		if (branding) {
			getShowUndoChanged();
		}
	}, [brandingProfile]);

	useEffect(() => {
		getBrandingDetail();
	}, []);

	return (
		<div>
			<SettingHeaderComponent
				title={activeTab}
				buttons={[
					{
						id: 1,
						disabled: !isEdit || loader,
						className: 'btn-primary',
						add: false,
						close: false,
						button: 'Save',
						loader: loader,
						handler: () => {
							handlebrandingSave();
						},
					},
					isEdit && {
						id: 2,
						disabled: false,
						className: 'btn-primary',
						add: false,
						close: false,
						button: 'Undo Changes',
						handler: () => {
							setIsEdit(false);
							getBrandingDetail();
						},

					},
				].filter((button) => button !== false)}
			/>

			<div className="p-4">
				<div className="row align-items-center my-4">
					{/* Upload Section */}
					<div className="col-4 col-lg-2  text-sm font-medium">Upload Your Organization Logo</div>
					<div className="col-8 col-lg-6 my-2">
						<div
							className={`upload-section text-center p-4 ${isDragging ? 'border-primary bg-light' : ' cursor-pointer'
								}`}
							onClick={handleBoxClick}
							onDragOver={handleDragOver}
							onDragLeave={handleDragLeave}
							onDrop={handleDrop}
						>
							<input
								ref={fileInputRef}
								type="file"
								accept="image/*"
								onChange={handleFileInput}
								style={{ display: 'none' }}
							/>
							{(brandingProfile.organisation_logo !== null &&
								brandingProfile.organisation_logo !== '') ||
								uploadedLogo ? (
								<div>
									<img
										src={
											brandingProfile.organisation_logo !== null &&
												brandingProfile.organisation_logo !== ''
												? brandingProfile.organisation_logo
												: uploadedLogo
										}
										alt="Organization Logo"
										style={{ maxWidth: '150px', maxHeight: '150px' }}
										className="mb-2"
									/>
									<div className="fw-medium mb-2">{selectedFile?.name}</div>
									<div className="text-muted small mb-2">
										{selectedFile && `${(selectedFile.size / 1024).toFixed(2)} KB`}
									</div>
									<div className="d-flex align-item-center gap-4 justify-content-center">
										<Button
											className="btn btn-outline-danger btn-sm cursor-pointer px-4"
											button="Remove"
											onClick={handleRemove}
										></Button>
										{brandingProfile.organisation_logo === null ||
											brandingProfile.organisation_logo === '' ? (
											<Button
												className="btn btn-primary btn-sm cursor-pointer px-4"
												button="Upload"
												onClick={handleUploadLogo}
											></Button>
										) : (
											''
										)}
									</div>
								</div>
							) : (
								<div className="p-4">
									<img
										src={upload}
										alt="search-icon"
										width="24"
										height="24"
										className="rounded-circle me-2"
									/>
									<div className="text-sm font-medium my-2">Drag And Drop Here</div>
									<div className="text-sm font-medium my-2">Or Click to Browse</div>
									<div className="fs-5 text-gray">No File Chosen</div>
								</div>
							)}
						</div>
					</div>
				</div>
				<div className="row align-items-center my-4">
					{/* Upload Section */}
					<div className="col-4 col-lg-2 text-sm font-medium">Preference</div>
					<div className="col-8 col-lg-6 d-flex my-2 gap-4">
						<div>
							<img
								src={darkTheme}
								alt="search-icon"
								width="148"
								height="100"
							/>
							<div className="my-2 d-flex align-items-center gap-3">
								<input
									type="radio"
									value={brandingProfile.isDark}
									checked={brandingProfile.isDark}
									id="dark"
									name="theme"
									onChange={(e) => {
										var value = e.target.checked;
										handleForm('isDark', value);
									}}
									className="form-radio-input m-2 p-2"
								/>
								<label
									htmlFor="dark"
									className="fw-bold fs-5"
								>
									Dark
								</label>
							</div>
						</div>
						<div>
							<img
								src={darkTheme}
								alt="search-icon"
								width="148"
								height="100"
							/>
							<div className="my-2 d-flex align-items-center gap-2">
								<input
									type="radio"
									value={!brandingProfile.isDark}
									checked={!brandingProfile.isDark}
									id="dark"
									name="theme"
									onChange={(e) => {
										var value = e.target.checked;
										handleForm('isDark', !value);
									}}
									className="form-radio-input m-2 p-2"
								/>
								<label
									htmlFor="light"
									className="fw-bold fs-5"
								>
									Light
								</label>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}
